/* jshint esversion: 6 */
import React from 'react';
import SocialPanelModule from 'app/mixins/SocialPanelModule.js';
import Toggle from 'app/components/common/ToggleControl.jsx';
import ErrorModule from 'app/mixins/ErrorModule.jsx';
import FieldError from 'app/components/common/FieldError.jsx';
import HelpButton from 'app/components/common/HelpButton.jsx';
import StyledSelect from 'app/components/common/StyledSelect.jsx';
import { Link } from 'react-router-dom';

class TwitterOptions extends React.Component {
    render() {
        let currentPanel = null,
            postTitle = (parseInt(this.props.getParamValue('postTitle'), 10)) ? true : false,
            postBody = (parseInt(this.props.getParamValue('postBody'), 10)) ? true : false,
            postImages = (parseInt(this.props.getParamValue('postImages'), 10)) ? true : false,
            postUrl = (parseInt(this.props.getParamValue('postUrl'), 10)) ? true : false,
            postQrCode = (parseInt(this.props.getParamValue('postQrCode'), 10)) ? true : false,
            /*
             * Unset reads as dark, which is what the server posts for it (postTwitter's
             * DEFAULT_PARAMS). Parsed as it was, an account that had never saved the setting
             * showed Light while its cards went out dark.
             */
            storedDarkQR = this.props.getParamValue('postDarkQR'),
            postDarkQR = (storedDarkQR === undefined || storedDarkQR === null || storedDarkQR === '')
                ? true
                : (parseInt(storedDarkQR, 10) ? true : false),
            prefixSpace = (parseInt(this.props.getParamValue('prefixSpace'), 10)) ? true : false,
            postfixSpace = (parseInt(this.props.getParamValue('postfixSpace'), 10)) ? true : false,
            postAsRetweet = (parseInt(this.props.getParamValue('postAsRetweet'), 10)) ? true : false,
            socialStats = (parseInt(this.props.getParamValue('socialStats'), 10)) ? true : false,
            controlState = this.props.getControlState();

        /*
        // removed postAsRetweet on 9/13/17 in response to abuse
        <fieldset>
            <legend>Post as Retweet{statusLabel}<HelpButton which="postAsRetweet"/></legend>
            <ErrorModule
                app={this.props.app}
                keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE']}
                render={(state) => {
                    return (
                        <FieldError field={this.props.errorMapping + '.postAsRetweet'} errors={state.errors}/>
                    );
                }}/>
            <Toggle
                active={postAsRetweet}
                noLabel={true}
                callback={this.props.changeHandler}
                linkedField={this.props.fieldMapping + ".postAsRetweet"}
                controlState={controlState} />
        </fieldset>
         */

        let visibleSettings = null;
        if (this.props.hasInputOverrides) {
            if (this.props.user.detail.routeViewType === this.props.app.config.constants.ROUTE_VIEW_SIMPLE) {
                visibleSettings = this.props.generateInputOverrideLink();
            } else {
                visibleSettings = (
                    <div>
                        {this.props.generateInputOverrideWarning()}
                        {this.props.getPostTitle(postTitle)}
                        {this.props.getPostBody(postBody)}
                        {this.props.getPostPhoto(postImages)}
                        {this.props.getPostUrl(postUrl)}
                    </div>
                )
            }
        } else {
            visibleSettings = (
                <div>
                    {this.props.getPostTitle(postTitle)}
                    {this.props.getPostBody(postBody)}
                    {this.props.getPostPhoto(postImages)}
                    {this.props.getPostUrl(postUrl)}
                </div>
            );
        }

        let qrCodeSetting = (
            <fieldset>
                <legend>Add a QR Code for the Link<HelpButton {...this.props} which="postQrCode"/>{this.props.getParamStateLabel('postQrCode')}</legend>
                <ErrorModule
                    app={this.props.app}
                    keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE', 'OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                    render={(state) => {
                        return (
                            <FieldError field={this.props.errorMapping + ".postQrCode"} errors={state.errors}/>
                        );
                    }}/>
                <Toggle
                    active={postQrCode}
                    noLabel={true}
                    callback={this.props.changeHandler}
                    linkedField={this.props.fieldMapping + ".postQrCode"}
                    controlState={controlState} />
            </fieldset>
        );

        /*
         * Only rendered when codes are on — see the render below; nothing to theme otherwise.
         *
         * Two named choices rather than a switch, because "off" does not say what you get: both
         * are themes. Still the one postDarkQR param, 1 for dark and 0 for light -
         * FormUtilityMixin.requestChange stores a checked radio's numeric value as it is.
         */
        const qrThemeField = this.props.fieldMapping + ".postDarkQR",
            qrThemeId = qrThemeField.replace(/[^A-Za-z0-9_-]/g, '-'),
            qrThemeDisabled = controlState === 'disabled';

        let darkQrSetting = (
            <fieldset>
                <legend>QR Card Theme<HelpButton {...this.props} which="postDarkQR"/>{this.props.getParamStateLabel('postDarkQR')}</legend>
                <ErrorModule
                    app={this.props.app}
                    keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE', 'OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                    render={(state) => {
                        return (
                            <FieldError field={this.props.errorMapping + ".postDarkQR"} errors={state.errors}/>
                        );
                    }}/>
                {/* Side by side (Emily): two short options read as one choice on a line */}
                <div className="inline-checkbox-wrapper">
                    <div className="inline-checkbox">
                        <input
                            id={qrThemeId + '-dark'}
                            type="radio"
                            name={qrThemeField}
                            value="1"
                            checked={postDarkQR}
                            disabled={qrThemeDisabled}
                            data-field={qrThemeField}
                            onChange={this.props.changeHandler} />
                        <label htmlFor={qrThemeId + '-dark'}>Dark mode</label>
                    </div>
                    <div className="inline-checkbox">
                        <input
                            id={qrThemeId + '-light'}
                            type="radio"
                            name={qrThemeField}
                            value="0"
                            checked={!postDarkQR}
                            disabled={qrThemeDisabled}
                            data-field={qrThemeField}
                            onChange={this.props.changeHandler} />
                        <label htmlFor={qrThemeId + '-light'}>Light mode</label>
                    </div>
                </div>
            </fieldset>
        );

        if (this.props.activePanel !== 'advanced') {
            currentPanel = (
                <div>
                    {visibleSettings}
                    {qrCodeSetting}
                    {postQrCode ? darkQrSetting : null}
                    {this.props.getPrefixText(prefixSpace)}
                    {this.props.getPostfixText(postfixSpace)}
                    {this.props.getActiveToggle()}
                    {this.props.getDeleteButton()}
                </div>
            );
        } else {
            currentPanel = (
                <div>
                    {this.props.getSocialStats(socialStats)}
                    <fieldset>
                        <legend>Text Truncation Length</legend>
                        <ErrorModule
                            app={this.props.app}
                            keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE', 'OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                            render={(state) => {
                                return (
                                    <FieldError field="truncationLength" errors={state.errors}/>
                                );
                            }}/>
                        <StyledSelect options={[{value: 280, label: '280 characters - Default'}, {value: 140, label: '140 characters'}]}
                                      linkedField={this.props.fieldMapping + ".truncationLength"}
                                      onChange={this.props.changeHandler}
                                      value={this.props.getParamValue('truncationLength')}
                                      selectClass="large"
                                      controlState={controlState}/>
                    </fieldset>
                </div>
            );
        }

        return this.props.getPanelOutput(currentPanel);
    }

};

export default SocialPanelModule(TwitterOptions);
